import { Stack, Typography } from '@mui/material';
import PaiTextField from 'features/ui/base-components/pai-text-field';
import React from 'react';
import { BasicActionDialog } from '../../../../ui/base-dialogs';

interface Props {
  open: boolean;
  name: string;

  handleTextFieldChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleClose(): void;

  handleProceed(): void;
}

const CloneQuestionnaireDialog: React.FC<Props> = ({ open, name, handleTextFieldChange, handleClose, handleProceed }) => {
  return (
    <BasicActionDialog
      dialogTitle={'Fragebogen kopieren'}
      maxWidth={'xs'}
      cancelButtonText={'Abbrechen'}
      proceedButtonText={'Kopieren'}
      open={open}
      handleClose={handleClose}
      handleProceed={handleProceed}
      proceedButtonDisabled={name.trim() === ''}
    >
      <Stack gap={2}>
        <PaiTextField
          value={name}
          placeholder={'Name zu bewertender Führungskraft...'}
          label={'Geben Sie den Namen für den neuen Fragebogen in das Textfeld ein.'}
          onChange={handleTextFieldChange}
        />
        <Typography sx={{ fontSize: '13px' }}>Es wird ein neuer Fragebogen mit dem selben Fragenkatalog erstellt.</Typography>
      </Stack>
    </BasicActionDialog>
  );
};

export default CloneQuestionnaireDialog;
